<TextCell text={item.title} />

<script>
    import TextCell from "@itslearning/prometheus/assets/lists/TextCell/v1/TextCell.svelte";

    export let item;
</script>
